<template>
  <e-layout-publico titulo="Pré-matrícula">
    <p v-if="periodo && periodo.aberto">
      Pré-matrículas abertas até <strong>{{ formatarData(periodo.data_fechamento) }}</strong
      >.
    </p>
    <v-alert v-else-if="periodo" type="info" outlined dense>
      Não há período de pré-matrícula aberto no momento. Se você já fez a pré-matrícula, informe os
      dados abaixo para recuperar o boleto.
    </v-alert>

    <p>
      Informe o CPF e a data de nascimento do <strong>aluno</strong>. Se a pré-matrícula já foi
      feita, é por aqui que você recupera o boleto.
    </p>

    <ValidationObserver v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(consultar)">
        <ValidationProvider name="CPF do aluno" rules="required|cpfValido" v-slot="{ errors }">
          <e-label>CPF do aluno</e-label>
          <v-text-field
            v-model="cpf"
            v-mask="'###.###.###-##'"
            inputmode="numeric"
            autocomplete="off"
            :error-messages="errors"
            dense
            solo
          />
        </ValidationProvider>
        <ValidationProvider
          name="Data de nascimento"
          rules="required|data_valida"
          v-slot="{ errors }"
        >
          <e-label>Data de nascimento do aluno</e-label>
          <e-date-picker
            v-model="dataNascimento"
            placeholder="dd/mm/aaaa"
            inputmode="numeric"
            :error-messages="errors"
          />
        </ValidationProvider>

        <v-alert v-if="aviso" :type="aviso.tipo" outlined role="alert">{{ aviso.texto }}</v-alert>

        <v-btn block color="primary" type="submit" :loading="consultando" :disabled="consultando">
          Continuar
        </v-btn>
        <v-btn block text class="mt-2" :to="{ name: 'login' }">Voltar ao login</v-btn>
      </v-form>
    </ValidationObserver>
  </e-layout-publico>
</template>

<script>
import ELayoutPublico from "@/components/PreMatriculas/ELayoutPublico.vue";
import { formatarData, mensagemDeErro } from "@/components/PreMatriculas/helpers";

export default {
  name: "PreMatriculaEntradaPage",
  components: { ELayoutPublico },
  data() {
    return {
      periodo: null,
      cpf: "",
      dataNascimento: null,
      consultando: false,
      aviso: null,
    };
  },
  async mounted() {
    try {
      this.periodo = await this.$services.preMatriculasService.periodoVigente();
    } catch (error) {
      // Sem a informação do período a consulta ainda funciona: a API responde se está fechado.
    }
  },
  methods: {
    formatarData,
    async consultar() {
      this.consultando = true;
      this.aviso = null;
      try {
        const resposta = await this.$services.preMatriculasService.consultarCpf(
          this.cpf,
          this.dataNascimento
        );
        this.seguirPara(resposta);
      } catch (error) {
        this.aviso = { tipo: "error", texto: mensagemDeErro(error) };
      }
      this.consultando = false;
    },
    seguirPara(resposta) {
      if (resposta.destino === "BOLETO" && resposta.boleto) {
        this.$router.push({ name: "preMatricula.boleto", params: { boleto: resposta.boleto } });
        return;
      }
      if (resposta.destino === "BOLETO") {
        // Pré-matrícula existe, mas o boleto não pôde ser exibido (já pago ou falha na emissão).
        this.aviso = { tipo: "warning", texto: resposta.message };
        return;
      }
      if (resposta.destino === "JA_MATRICULADO") {
        this.aviso = {
          tipo: "info",
          texto:
            "Este aluno já está matriculado para o ano letivo. Em caso de dúvida, procure a secretaria da escola.",
        };
        return;
      }
      this.$router.push({
        name: "preMatricula.formulario",
        params: {
          cpf: resposta.cpf,
          dataNascimento: this.dataNascimento,
          completo: resposta.destino === "FORMULARIO_COMPLETO",
        },
      });
    },
  },
};
</script>
